import { NCListItem, NCListItemType, NCParsedLine } from '@components/common/NCFile/types';

export const prepareNCFileListItems = (parsedLines: NCParsedLine[], expandedSections: Set<number>): NCListItem[] => {
  const items: NCListItem[] = [];

  for (let i = 0; i < parsedLines.length; i++) {
    const line = parsedLines[i];

    if (line.isToolCall) {
      items.push({
        type: NCListItemType.TOOL_CALL_HEADER,
        key: line.key,
        line,
        sectionIndex: line.toolSectionIndex!,
      });
      continue;
    }

    if (line.toolSectionIndex !== null) {
      if (expandedSections.has(line.toolSectionIndex)) {
        items.push({
          type: NCListItemType.TOOL_CALL_LINE,
          key: line.key,
          line,
          sectionIndex: line.toolSectionIndex,
        });
      }
      continue;
    }

    items.push({
      type: NCListItemType.LINE,
      key: line.key,
      line,
    });
  }

  return items;
};
